import type { DeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useDeviceSettingsList } from "./useDeviceSettingsList"
import { useFollowedUsers } from "src/contexts/FollowedUsersContext"

// TODO usually we should just use the currentDeviceSettings from the FollowedUsersContext
export function useDeviceSettings(followingAccountId?: DeviceSettings["following_account_id"]) {
  const { data: deviceSettingsList } = useDeviceSettingsList()
  const { currentUserId } = useFollowedUsers()

  const accountId = followingAccountId ?? currentUserId

  return useMemo(
    () => deviceSettingsList?.find(
      (deviceSettings) => deviceSettings.following_account_id === accountId,
    ),
    [
      deviceSettingsList,
      accountId,
    ],
  )
}
